import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./components/_default/context/ShoppingCartContext"
import store from "./store/store"
import Redirect from "./components/_default/utilities/Redirect"
import TagManager from 'react-gtm-module'
// Pages
import Webpage2Avaleht from "./pages/Webpage2Avaleht";
import Webpage12Lehte_ei_leitud from "./pages/Webpage12Lehte_ei_leitud";
import Webpage14Tingimused from "./pages/Webpage14Tingimused";

var baseURL = 'https://web.kassahaldus.ee/webstoreApi';
var axiosHeaders = {
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI2IiwianRpIjoiNTg4N2VjYjQ0OWIyMGJkZmU2NmU2MzUxNzIyYjg1YWRhZTUzOWM3YmU5NDc2MzM3MmIwNDBkZTI4Y2JlMjRhOTQ3YjBiNzhkMjAxYjM0ZTMiLCJpYXQiOjE3ODQ0NjMyODYuMjE5NDk0LCJuYmYiOjE3ODQ0NjMyODYuMjE5NDk4LCJleHAiOjE3ODQ1NDk2ODYuMjE1Njg1LCJzdWIiOiI4Iiwic2NvcGVzIjpbXX0.BRWaCO0ecfhUszbTx7O1IOgv-37VKDabYq_eOqxnIogSUQIIBOq1HC4lHUI93Xc9aKcPFlUHclf5WAS2fR8jdxyf7tka9G4Dygyrg84hV4XSpbn7bZ9VKKo04cAOcZikTtpGozDehtKm25FgJ4Ts4PDOTPn_YeTWFFKWQgwNgmFHhO4Vj7iKTotFuYPKT88RcGbXTDhqSePCvUmCdyEA8Ye7NnPeUxcfISpxRMhDZehr0wlz4Zy-qtKQJd0ev-nai-g6H0K9ow0kIBv5VVyWyVlPux2L0SLAe22rzGjIMREdp3DeywiN3k3wpYzUbO0t1dxCX4Cy69_rM2G3UkS_nxwhksVZPb4822fo47OJcimM8hJ7Yl97Mm11AT82SERb5nLmc0O87tCZUKAcwLNa6Th02xKCPaTyzK8M9qJVHbZ4f0cfqjKpA49VaP0YhIKiY6dOUXMPijOz_E-nz9rD5BugrCuwapsYK03UNKug_7sHLhAjPhgLHasnjBxLHlbjvE_I3i-hwjrjan-4BZa7N7L3O2pQAaKKbaXZ0586Kr9YxEeQXrqAqrx7moVE1Eb7y0dkxM0jb12FDzMjQs0eHJQmdS4tNxZfx1xG-bA6o36Tr49bJFDR00w7_GDAVmzdJ6EqwDCsJWHyrSqWvr8AJ-pm6uPZdeCGFfIe7T5t5OI',
    'Access-api-key': "eyJpdiI6IjhqTFdEVWNTRlZhYlhvMjB1RDdxanc9PSIsInZhbHVlIjoiSVNtcVYwVWJCdlRRRU5URlNhbmtaZz09IiwibWFjIjoiNTNjZWViYzc0ZDlhNWRlYWY0NDJlYjY2N2U5ZDk1MzI1M2RmM2YwYmExYzAxNmMzYWZlZGY4NmQ1ZjA1ZmVmMiIsInRhZyI6IiJ9",
    'Access-api-id': "eyJpdiI6IkhSaHRPb0tOV3dySzVpN1owbDZqV3c9PSIsInZhbHVlIjoiZDZRam9HMmpQR3pCY1dXK2k2bFZ6QT09IiwibWFjIjoiMjE5N2ZmMjkwYTNkNjllNDhjNDM1Y2YxOTU0MjdkMTY4ZGFjYjc2OGZkMDQ1YWE5ZTRhMWE4ZjhjYzllYmIwNSIsInRhZyI6IiJ9",
    'Access-Control-Allow-Origin': "*"
 };


window.axios = require('axios').create({
  baseURL: baseURL,
  headers: axiosHeaders
});
const tagManagerArgs = {
    gtmId: "GTM-KHPWXL9"
}
TagManager.initialize(tagManagerArgs)
    
export default function App() {
    window.dataLayer.push({
        event: 'pageview'
    });
    return (
        <Provider store={store}>
            <ShoppingCartProvider>
                <BrowserRouter basename="/">
                    <Routes>
                                            <Route path="/et/" element={<Webpage2Avaleht />} exact />;
                                                                    <Route path="/et/*" element={<Webpage12Lehte_ei_leitud />} exact />;
                                                <Route path="*" element={<Webpage12Lehte_ei_leitud />} exact />;
                                                                    <Route path="/et/tingimused" element={<Webpage14Tingimused />} exact />;
                                                                
                                                            </Routes>
                </BrowserRouter>
            </ShoppingCartProvider>
        </Provider>
    );
}